@if ((spinner$ | async)?.show) {
  <div class="spinner">
    <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="medium" color="#000" type="ball-scale-ripple-multiple" [fullScreen]="false"><p style="color: black" > Loading... </p></ngx-spinner>
  </div>
}
@if (blogPost) {
  <div class="toolbar-break">
  </div>
  <div class="container mt-5">
    <div class="row">
      <div class="col-12 col-lg-5">
        @if (blogPost.read_time) {
          <div class="d-flex justify-content-center align-items-center badge">
            <p class="mb-0 pb-0">{{blogPost.read_time}} minute read</p>
          </div>
        }
        <app-image class="blog-image" [prismicImage]="blogPost.blog_hero_image" [bcimage]="true"></app-image>
      </div>
      <div class="col-12 col-lg-7 ps-lg-5">
        <div class="break d-flex justify-content-between align-items-center">
          <div class="">
            <p class="title-secondary">{{blogPost.category | uppercase}}</p>
          </div>
          <div>
            <p class="">{{blogPost.last_modified_date | date:'M/d/yyyy' }}</p>
          </div>
        </div>
        <h1>{{blogPost.blog_title}}</h1>
        <div class="d-flex justify-content-start align-items-center">
          <img class="headshot" [src]="blogPost.blog_author_image.url" [alt]="blogPost.blog_author" />
          <div class="ms-3 mt-3" [innerHTML]="blogPost.blog_author"></div>
        </div>
        <div class="mt-4 mb-2" style="width: 20%;">
          <div class="line-break"></div>
          <br />
        </div>
        <div [innerHTML]="blogPost.introduction"></div>
      </div>
      <div>
        <img class="wave-right" src="assets/images/pink-curve-right.png" alt="Pink Wave Decoration">
      </div>
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[0].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[0].paragraph"></div>
      @if (blogPost.blogParagraph.subsections[0].image?.url) {
        <div class="d-flex justify-content-center mt-5">
          <app-image class="paragraph-image" [prismicImage]="blogPost.blogParagraph.subsections[0].image"></app-image>
        </div>
      }
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[1].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[1].paragraph"></div>
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[2].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[2].paragraph"></div>
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h3>{{blogPost.blogParagraph.subsections[3].subtitle}}</h3>
      <div [innerHtml]="blogPost.blogParagraph.subsections[3].paragraph"></div>
      <div class="d-flex justify-content-center w-100 my-3">
        @if (sanitizer) {
          <app-product-card [product]="sanitizer"></app-product-card>
        }
      </div>
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h3>{{blogPost.blogParagraph.subsections[4].subtitle}}</h3>
      <div [innerHtml]="blogPost.blogParagraph.subsections[4].paragraph"></div>
      <div class="d-flex justify-content-center w-100 my-3">
        @if (oxidizer) {
          <app-product-card [product]="oxidizer"></app-product-card>
        }
      </div>
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h3>{{blogPost.blogParagraph.subsections[5].subtitle}}</h3>
      <div [innerHtml]="blogPost.blogParagraph.subsections[5].paragraph"></div>
      <div class="d-flex justify-content-center w-100 my-3">
        @if (testStrips) {
          <app-product-card [product]="testStrips"></app-product-card>
        }
      </div>
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h3>{{blogPost.blogParagraph.subsections[6].subtitle}}</h3>
      <div [innerHtml]="blogPost.blogParagraph.subsections[6].paragraph"></div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="d-flex justify-content-center w-100 my-3">
            @if (spaDown) {
              <app-product-card [product]="spaDown"></app-product-card>
            }
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="d-flex justify-content-center w-100 my-3">
            @if (spaUp) {
              <app-product-card [product]="spaUp"></app-product-card>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center w-100">
      <img class="sirona-guide w-100" src="/assets/images/cold_plunge_care_instructions.png" />
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[7].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[7].paragraph"></div>
    </div>
    <div class="my-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[8].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[8].paragraph"></div>
    </div>
    <div class="mt-5 py-5 mx-0 mx-lg-5 px-3 px-lg-5">
      <h2>{{blogPost.blogParagraph.subsections[9].subtitle}}</h2>
      <div [innerHtml]="blogPost.blogParagraph.subsections[9].paragraph"></div>
      @if (blogPost.blogParagraph.subsections[9].image?.url) {
        <div class="d-flex justify-content-center mt-5">
          <app-image class="paragraph-image" [prismicImage]="blogPost.blogParagraph.subsections[9].image"></app-image>
        </div>
      }
    </div>
    <div class="d-flex justify-content-center w-100 mb-5">
      <a class="link important" routerLink="/brands/sirona">View all of our Sirona Spa Care products.</a>
    </div>
    <p class="text-center mb-5">
      For traditional spas and hot tubs, browse our complete selection of
      <a class="link important" routerLink="/brands/spaguard">SpaGuard water care products</a>.
    </p>
  </div>
}
